
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/CheckOrgUsers/CheckOrgUsers.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./CheckOrgUsers.html');
        
        var script = require('./CheckOrgUsers.ts').default;
        module.exports = require('./CheckOrgUsers.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    